import { TableBody } from './Body';
import { TableCell } from './Cell';
import { TableFilters } from './Filters';
import { TableFooter } from './Footer';
import { TableHead } from './Head';
import { TablePagination } from './Pagination';
import { TableRoot } from './Root';
import { TableRow } from './Row';
import { TableToolbar } from './Toolbar';

export const Table = {
  Body: TableBody,
  Cell: TableCell,
  Root: TableRoot,
  Filters: TableFilters,
  Footer: TableFooter,
  Head: TableHead,
  Pagination: TablePagination,
  Row: TableRow,
  Toolbar: TableToolbar,
};
